import { render, staticRenderFns } from "./OnSiteMessageGeneral.vue?vue&type=template&id=9749bc2e&scoped=true&"
import script from "./OnSiteMessageGeneral.vue?vue&type=script&lang=js&"
export * from "./OnSiteMessageGeneral.vue?vue&type=script&lang=js&"
import style0 from "./OnSiteMessageGeneral.vue?vue&type=style&index=0&id=9749bc2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9749bc2e",
  null
  
)

export default component.exports